<template>
  <div class="lesson-content">
    <h1 class="lesson-title">{{ lesson.order + 1 }}. {{ lesson.title }}</h1>
    <div class="lesson-html" v-html="lesson.content"></div>
  </div>
</template>

<script>

export default {
  props: {
    lesson: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.lesson-content {
  font-family: Georgia, serif;
  @include text-size-l();
  color: $color-text-dark;
}

.lesson-title {
  margin-bottom: 2rem;
  @include text-size-xxxl();
  font-weight: $font-weight-bold;
}

.lesson-html {

  h1 {
    margin-bottom: 2rem;
  }

  p {
    margin-bottom: 2rem;
  }

  ul {
    list-style-type: initial;
  }

  ul,
  ol {
    margin-left: 10px;

    li {
      display: list-item;
    }
  }
}

.social-block,
.orientation-block {
  font-family: 'Averta', $system-fonts;

  h3 {
    font-size: 1.1rem;
    font-weight: bolder;
    color: #0a2239;
  }

  p {
    font-size: 1rem;
    line-height: 1.2rem;
    color: #6B7285;
  }

  a {
    font-size: 0.9rem;
    font-weight: bolder;
    color: #E31C79;
  }
}

.social-block {
  padding: 1rem 0 2rem 0;
}

.orientation-block {
  padding-bottom: 2rem;

  .box {
    border-radius: 0;
    box-shadow: none;
    border: 1px solid #c4c7ce;
    padding: 1rem;
    margin-bottom: 0.6rem;
  }

  h3 {
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 0 !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/LessonContent.vue